module.exports = __webpack_public_path__ + "static/media/dana4.3589f246.jpg";